import { SlideComponentBackground } from '@/types/slide';
import { SlideComponentCreator } from './factory';
import { CANVAS_SIZE } from '@/constant';

export class SlideComponentBackgroundCreator extends SlideComponentCreator {
    public create(id: string): SlideComponentBackground {
        return {
            id: id,
            type: 'background',
            pos: {
                x: 0,
                y: 0,
            },
            size: CANVAS_SIZE,
            content: {
                filename: '',
                imageURL: '',
                flip: 1,
            },
        };
    }
}
